document.addEventListener('DOMContentLoaded', init);

function init() {
  var containers = document.querySelectorAll('.rte');
  containers.forEach(processContainer);
}

function processContainer(container) {
  var regex = /\[\[product:\s*(https?:\/\/[^\]\s]+)\s*\]\]/g;
  var html = container.innerHTML;
  var matches = [];
  var m;
  while ((m = regex.exec(html)) !== null) {
    matches.push(m);
  }
  if (matches.length === 0) return;

  var jobs = [];
  matches.forEach(function (match, i) {
    var id = 'cs-product-' + Date.now() + '-' + i;
    html = html.replace(match[0], '<div class="cs-card-loading" id="' + id + '">Loading product…</div>');
    jobs.push({ id: id, url: match[1].trim() });
  });

  container.innerHTML = html;
  jobs.forEach(function (job) {
    renderCard(job.id, job.url);
  });
}

function renderCard(id, url) {
  var el = document.getElementById(id);
  if (!el) return;

  var handle = extractHandle(url);
  if (!handle) {
    el.outerHTML = cardError(url);
    return;
  }

  fetch('/products/' + handle + '.js')
    .then(function (res) {
      if (!res.ok) throw new Error('Product not found: ' + handle);
      return res.json();
    })
    .then(function (product) {
      var target = document.getElementById(id);
      if (!target) return;
      target.outerHTML = cardHtml(product, url);
    })
    .catch(function (err) {
      var target = document.getElementById(id);
      if (target) target.outerHTML = cardError(url);
      console.error('CS Product Card error:', err);
    });
}

function extractHandle(url) {
  var parts = url.split('/products/')[1];
  if (!parts) return null;
  return parts.split('?')[0].split('#')[0].replace(/\/$/, '');
}

function withUtm(url) {
  if (url.indexOf('utm_') !== -1) return url;
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return url + separator + 'utm_source=Website&utm_medium=Blog&utm_campaign=Website_Blog';
}

function cardHtml(product, url) {
  var taggedUrl = withUtm(url);
  var price = formatMoney(product.price);
  var compareHtml = '';
  if (product.compare_at_price && product.compare_at_price > product.price) {
    compareHtml =
      '<span class="cs-old-price">' + formatMoney(product.compare_at_price) + '</span>' +
      '<span class="cs-sale-badge">Sale</span>';
  }

  var ctaHtml = product.available
    ? '<a class="cs-button" href="' + taggedUrl + '">Shop Now →</a>'
    : '<span class="cs-sold-out">Out of Stock</span>';

  var image = product.featured_image || (product.images && product.images[0]) || '';

  return (
    '<div class="cs-card">' +
      '<a href="' + taggedUrl + '" class="cs-image-link"><img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="170" height="170"></a>' +
      '<div class="cs-info">' +
        '<h3>' + escapeHtml(product.title) + '</h3>' +
        '<div class="cs-price">' + price + compareHtml + '</div>' +
        ctaHtml +
      '</div>' +
    '</div>'
  );
}

function cardError(url) {
  return '<div class="cs-card cs-card-error">Couldn\'t load this product. <a href="' + url + '">View it here →</a></div>';
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function escapeHtml(str) {
  var div = document.createElement('div');
  div.textContent = str || '';
  return div.innerHTML;
}